import { bemJoin } from 'bem-join'

import { createLayoutComponent } from '@app/lib/createLayoutComponent'

import './PortalContentLayout.scss'

const b = bemJoin('portal-content')

export const PortalContentLayout = createLayoutComponent('main', b(), {
  TopPane: createLayoutComponent('div', b('top-pane'), {}),
  MainPane: createLayoutComponent('div', b('main-pane'), {
    Content: createLayoutComponent('div', b('main-pane-content'), {}),
    Sidebar: createLayoutComponent('div', b('sidebar'), {})
  }),
  Section: createLayoutComponent('div', b('section'), {}),
  Container: createLayoutComponent('div', b('container'), {}),
  Header: createLayoutComponent('header', b('header'), {
    Heading: createLayoutComponent('h1', b('heading')),
    HeaderIcon: createLayoutComponent('div', b('header-icon')),
    Subheading: createLayoutComponent('div', b('subheading'))
  }),
  Content: createLayoutComponent('div', b('content')),
  Footer: createLayoutComponent('footer', 'div', b('footer'))
})
